import { Button } from "src/components/shared";
import { useStore } from "../../../../../store";
import { useNavigate } from "react-router-dom";

interface Props {
  setIsOpen: (isOpen: boolean) => void;
}

const TopBar = ({ setIsOpen }: Props) => {
  const navigate = useNavigate();
  const { courseStore } = useStore();

  const upcomingSession: any[] = courseStore?.searchedCourses;
  const session = courseStore?.classDetails;

  const isFirstSession = upcomingSession[0]?.id === session?.id;
  const isLastSession =
    upcomingSession[upcomingSession.length - 1]?.id === session?.id;

  const handleNextSession = () => {
    const currentIndex = upcomingSession.findIndex((s) => s.id === session?.id);
    if (currentIndex < upcomingSession.length - 1) {
      navigate(
        `/course/${session?.courseId}?classId=${
          upcomingSession[currentIndex + 1]?.id
        }`
      );
    }
  };

  const handlePreviousSession = () => {
    const currentIndex = upcomingSession.findIndex((s) => s.id === session?.id);
    if (currentIndex > 0) {
      navigate(
        `/course/${session?.courseId}?classId=${
          upcomingSession[currentIndex - 1]?.id
        }`
      );
    }
  };

  return (
    <div className="sticky top-0 z-10 flex items-center justify-between px-5 py-3 sm:px-8 sm:py-6 bg-white bg-opacity-95 border-b border-black border-opacity-5 backdrop-blur-[30px]">
      <div className="flex items-center gap-3.5">
        <h3 className="text-body-medium font-body-medium-bold sm:text-body-large sm:font-body-large text-primary-gray-800">
          Class Details
        </h3>
        <div className="flex items-center gap-2">
          <div className="size-9 sm:size-10">
            <Button
              type="pale"
              icon="/images/icons/arrow-left-purple1.svg"
              customStyle={{
                borderRadius: "9999px",
                padding: "12px",
              }}
              isDisabled={isFirstSession}
              onClick={handlePreviousSession}
            />
          </div>
          <div className="size-9 sm:size-10">
            <Button
              type="pale"
              icon="/images/icons/arrow-right-purple1.svg"
              customStyle={{
                borderRadius: "9999px",
                padding: "12px",
              }}
              isDisabled={isLastSession}
              onClick={handleNextSession}
            />
          </div>
        </div>
      </div>
      <div className="size-9 sm:size-10">
        <Button
          type="pale"
          icon="/images/icons/close-black.svg"
          onClick={() => setIsOpen(false)}
          customStyle={{
            borderRadius: "9999px",
            padding: "12px",
          }}
        />
      </div>
    </div>
  );
};

export default TopBar;
